import type { AssetTimelineItemDetailsProps } from "./asset-timeline-item-details.type";

import { Row, Typography } from "antd";

import { AssetTimelineCauser } from "../asset-timeline-causer";
import { AssetTimelineConditionRating } from "../asset-timeline-condition-rating";
import { AssetTimelineInterventionDetails } from "../asset-timeline-intervention-details";

const { Text } = Typography;

export const AssetTimelineItemDetails = ({
  item,
}: AssetTimelineItemDetailsProps) => {
  const { type, description } = item;

  const hasDetails = description || type === "asset-event" ? true : false;

  if (!hasDetails) return null;

  return (
    <div className="timeline-item-details">
      {description ? (
        <Row>
          <Text>{description}</Text>
        </Row>
      ) : null}
      {type === "asset-event" && (
        <>
          <AssetTimelineConditionRating
            assetEvent={item.data}
            renderWrapper={(ratingNode) => <Row>{ratingNode}</Row>}
          />
          <AssetTimelineCauser
            assetEvent={item.data}
            renderWrapper={(causerNode) => (
              <Row className="modified-by">{causerNode}</Row>
            )}
          />
          <AssetTimelineInterventionDetails assetEvent={item.data} />
        </>
      )}
    </div>
  );
};
